module.exports = __webpack_public_path__ + "img/di11.106ad7e2.png";